import { useContext } from 'react';

import { ImpersonationContext } from '../ImpersonationContext';

const useImpersonation = () => useContext(ImpersonationContext);
export default useImpersonation;
